import { Injectable } from "@angular/core";
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(public router: Router, private readonly authSvc: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const roles: string[] = route.data?.roles;
    if (roles == null || roles.length === 0) {
      return of(this.authSvc.isAuthorized() || this.router.parseUrl("/sessions/403"));
    }

    // Roles may not be loaded yet (app reload/re-bootstrap), so wait for them before checking.
    return this.authSvc.ensureRolesLoaded().pipe(
      map(() => this.authSvc.isAuthorized(roles) || this.router.parseUrl("/sessions/403")),
      catchError(() => of(this.router.parseUrl("/sessions/403")))
    );
  }

  canActivateChild(): boolean | UrlTree {
    if (this.authSvc.isAuthorized()) {
      return true;
    }

    return this.router.parseUrl("/sessions/403");
  }
}
